import classNames from 'classnames';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Media(_ref) {
  var {
    className,
    image,
    style,
    title
  } = _ref;
  var computedClassName = classNames('prezly-slate-media', className, {
    'prezly-slate-media--image': !image.isGif(),
    'prezly-slate-media--video': image.isGif()
  });
  if (image.isGif()) {
    var video = image.toGifVideo().bestQuality();
    var sourceWebm = video.format('webm').cdnUrl;
    var sourceMp4 = video.format('mp4').cdnUrl;
    var poster = image.format('png').cdnUrl;
    return /*#__PURE__*/_jsxs("video", {
      poster: poster,
      preload: "none",
      autoPlay: true,
      className: computedClassName,
      loop: true,
      muted: true,
      playsInline: true,
      style: style,
      title: title
      // TODO: Some browsers are complaining about this property
      // eslint-disable-next-line react/no-unknown-property
      ,
      "webkit-playsinline": "true",
      children: [/*#__PURE__*/_jsx("source", {
        src: sourceWebm,
        type: "video/webm"
      }), /*#__PURE__*/_jsx("source", {
        src: sourceMp4,
        type: "video/mp4"
      })]
    });
  }
  return /*#__PURE__*/_jsx("img", {
    alt: title,
    className: computedClassName,
    src: image.format().cdnUrl,
    srcSet: [image.srcSet(1200), image.srcSet(800), image.srcSet(400)].filter(Boolean).join(', '),
    sizes: "(max-width: 992px) 800px, (max-width: 576px) 400px, 1200px",
    style: style,
    title: title
  });
}